import { render, staticRenderFns } from "./QuestionAlimentation.vue?vue&type=template&id=98522b18&scoped=true"
import script from "./QuestionAlimentation.vue?vue&type=script&lang=js"
export * from "./QuestionAlimentation.vue?vue&type=script&lang=js"
import style0 from "./QuestionAlimentation.vue?vue&type=style&index=0&id=98522b18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98522b18",
  null
  
)

export default component.exports